<template>
  <div :class="opened?'form-input opened':'form-input isset'">
    <input
        ref="input"
        @focus="onFocus"
        @blur="onBlur"
        @input="inputHandler"
        @click="clickHandler"
        :placeholder="modelValue?.text??placeholder"
    />
  </div>
  <div class="form-options" v-show="opened">
    <div v-if="loading">Загрузка...</div>
    <ul v-if="!loading">
      <li
          v-for="(option, index) in options"
          :key="index"
          @click="select(option)"
      >
        {{ option?.text }}
      </li>
    </ul>
    <div v-if="!loading && options.length === 0">Ничего не найдено...</div>

  </div>
</template>

<script setup>
import {defineProps, defineEmits, ref, } from 'vue'

  const opened = ref(false)
  const options = ref([{}])
  const searchCache = ref(null)
  const loading = ref(false)
  const focus = ref(false)
  const emit = defineEmits(['update:modelValue'])

  const props = defineProps({
    modelValue: {
      type: Object,
      required: true
    },
    label: String,
    placeholder: {
      type: String,
      default: 'Выберите из списка'
    },
    remoteMethod: {
      type: Function,
      required: true
    }
  })
  function clickHandler(){
    if (focus.value && !opened.value && searchCache.value !== null) {
      openClose()
    }
  }

let debounceTimer = null

async function inputHandler(event) {
  const val = event.target.value
  loading.value = true

  if (!opened.value) {
    openClose()
  }

  // Очищаем предыдущий таймер
  clearTimeout(debounceTimer)

  // Делаем запрос с задержкой
  debounceTimer = setTimeout(async () => {
    try {
      options.value = await props.remoteMethod(val)
    } catch (error) {
      console.error('Search error:', error)
    } finally {
      loading.value = false
    }
  }, 350)
}

function onFocus(event) {
    if (!opened.value && searchCache.value !== null) {
      openClose()
    }
    event.target.placeholder = event.target.value ==='' ? event.target.placeholder : event.target.value
    event.target.value = ''
    focus.value = true
  }

  function onBlur(event) {
    setTimeout(() => {
      event.target.value  = props.modelValue?.text ??''
    }, 100); // Что бы успел обновиться modelValue
    focus.value = false
  }
  function select(option) {
    emit('update:modelValue', option)
  }
  function openClose() {
    if (opened.value === false) {
      opened.value = true;
      setTimeout(() => {
        document.body.addEventListener('click', openClose);
      }, 100);
    } else {
      document.body.removeEventListener('click', openClose);
      opened.value = false;
    }
  }
</script>

<style scoped>
input {
  width: calc(100% - 30px);
  border: none;
  outline: none;
  height: 100%;
  padding: 0 0 0 10px;
  font-family: Gilroy;
  font-size: 16px;
  color: #626262;
}

.form-input {
  padding: 0 !important;
}
.form-input input::placeholder {
  color: #CFCFCF;
}

.form-input:after {
  content: "";
  border-style: solid;
  border-width: 6px 0 6px 6px;
  border-color: transparent transparent transparent #FA4B48;
  position: absolute;
  right: 10px;
  transform: translateY(-50%) rotate(90deg);
}

.form-input:focus-within:after {
  transform: translateY(-50%) rotate(-90deg);
}
</style>